var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.0339C41.2122 4.0339 51.9661 14.7878 51.9661 28C51.9661 41.2122 41.2122 51.9661 28 51.9661C14.7878 51.9661 4.0339 41.2122 4.0339 28C4.0339 14.7878 14.7878 4.0339 28 4.0339ZM28 0C12.5383 0 0 12.5383 0 28C0 43.4617 12.5383 56 28 56C43.4617 56 56 43.4617 56 28C56 12.5383 43.4617 0 28 0Z",
    fill: "#4EF100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5363 27.8322L25.5078 9.99765L29.5417 9.99121L29.5702 27.8258L25.5363 27.8322Z",
    fill: "#4EF100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3069 29.413L12.25 18.3364L14.7467 15.168L28.8036 26.2446L26.3069 29.413Z",
    fill: "#4EF100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0128 29.793L10.4914 33.8934L9.57227 29.9656L27.0936 25.8652L28.0128 29.793Z",
    fill: "#4EF100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3702 28.7013L21.5587 44.9792L17.9219 43.234L25.7334 26.9561L29.3702 28.7013Z",
    fill: "#4EF100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3722 26.9619L37.1268 43.2398L33.485 44.9747L25.7305 28.6968L29.3722 26.9619Z",
    fill: "#4EF100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0138 25.8652L45.4782 29.9656L44.5562 33.8927L27.0918 29.7923L28.0138 25.8652Z",
    fill: "#4EF100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3027 26.2475L40.3027 15.1709L42.8057 18.3344L28.8057 29.411L26.3027 26.2475Z",
    fill: "#4EF100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.4a0db505.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.0339C41.2122 4.0339 51.9661 14.7878 51.9661 28C51.9661 41.2122 41.2122 51.9661 28 51.9661C14.7878 51.9661 4.0339 41.2122 4.0339 28C4.0339 14.7878 14.7878 4.0339 28 4.0339ZM28 0C12.5383 0 0 12.5383 0 28C0 43.4617 12.5383 56 28 56C43.4617 56 56 43.4617 56 28C56 12.5383 43.4617 0 28 0Z",
    fill: "#4EF100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5363 27.8322L25.5078 9.99765L29.5417 9.99121L29.5702 27.8258L25.5363 27.8322Z",
    fill: "#4EF100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3069 29.413L12.25 18.3364L14.7467 15.168L28.8036 26.2446L26.3069 29.413Z",
    fill: "#4EF100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0128 29.793L10.4914 33.8934L9.57227 29.9656L27.0936 25.8652L28.0128 29.793Z",
    fill: "#4EF100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3702 28.7013L21.5587 44.9792L17.9219 43.234L25.7334 26.9561L29.3702 28.7013Z",
    fill: "#4EF100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3722 26.9619L37.1268 43.2398L33.485 44.9747L25.7305 28.6968L29.3722 26.9619Z",
    fill: "#4EF100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0138 25.8652L45.4782 29.9656L44.5562 33.8927L27.0918 29.7923L28.0138 25.8652Z",
    fill: "#4EF100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3027 26.2475L40.3027 15.1709L42.8057 18.3344L28.8057 29.411L26.3027 26.2475Z",
    fill: "#4EF100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.4a0db505.svg";
export { ForwardRef as ReactComponent };